module.exports = __webpack_public_path__ + "img/portnoy.164d6c69.jpg";